// export const snippetRoute = "http://localhost:5000/snippet";
// export const searchRoute = "http://localhost:5000/search";
// export const profileRoute = "http://localhost:5000/profile";
// export const searchOtherSnippetRoute = "http://localhost:5000/search/other";

export const snippetRoute = "https://recode-snippet.herokuapp.com/snippet";
export const searchRoute = "https://recode-snippet.herokuapp.com/search";
export const profileRoute = "https://recode-snippet.herokuapp.com/profile";
export const searchOtherSnippetRoute = "https://recode-snippet.herokuapp.com/search/other"
